import axiosInstance from "./axiosInstance";

const getProductById = async (productId: number, productType: string) => {
  const accessToken = localStorage.getItem("accessTokenGC");
  try {
    const { data } = await axiosInstance.get(
      `/api/getProductById/${productType}/${productId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return data;
  } catch (error) {
    throw new Error("Error fetching user points.");
  }
};

export default getProductById;
